<bp-create-password-form
	class="h-100"
	[email]="(identityFacade.incompleteIdentity$ | async)!.email"
	[pending]="introFacade.pending$ | async"
	[error]="introFacade.error$ | async"
	(submitted)="identityFacade.createPassword($event)"
	(login)="introFacade.gotoLoginPage()"
>
</bp-create-password-form>
